import { useEffect, useState } from "react";
import { useParams } from "react-router";
import React from 'react';
import Api from "../../Api/Api";
import { username } from "../../API";

import NavBar from "../Navbar";
import { Row, Col, Card } from "react-bootstrap";
import { Link } from "react-router-dom";

const About = (userData) => {
  const [user, setUser] = useState(null);
  const [configData, setConfigData] = useState(false);

  // const { username } = useParams();
  useEffect(() => {
    const getData = async () => {
      const { data } = await Api.getUserAbout(username);
      console.log(data);
      setUser(data);
    };
    getData();
  }, [username]);


  useEffect(() => {
    const getData = async () => {
      const { data } = await Api.getConfigText(username);
      console.log(data);
      for (let i = 0; i < data?.length; i++) {
        if (data[i].title === "About Us") {
          setConfigData(data[i]);
        }
      }
    };
    getData();
  }, [username]);


  console.log(user)
  return (
    <>
      <NavBar />
      {user && (
        <div>
          {/* <img
            src="https://www.pexels.com/photo/black-cloth-in-close-up-photography-7641124/"
            alt={user.about}
            height="500px"
            width="100%"
            style={{ position: "relative" }}
          />
          <div style={{ position: "absolute", top: "25%", width: "100%" }}>
            <Row>
              <Col md={{ span: 3, offset: 2 }}>
                <img src={user.picture} alt={user.about} />
              </Col>
              <Col md={{ span: 4, offset: 1 }} className="mt-5">
                <h3
                  className="text-white"
                  style={{ textShadow: "1px 1px 1px black" }}
                >
                  {user.firstName} {user.lastName}
                </h3>
                <br />
                {user.location.length && (
                  <p
                    className="text-white"
                    style={{ textShadow: "1px 1px 1px black" }}
                  >
                    {user.location}
                  </p>
                )}
                {user.profession.toString() !== "" && (
                  <p
                    className="text-white"
                    style={{ textShadow: "1px 1px 1px black" }}
                  >
                    {user.profession}
                  </p>
                )}
                <p
                  className="text-white"
                  style={{ textShadow: "1px 1px 1px black" }}
                >
                  {user.publicUrl}
                </p>
                <div className="pb-4 mt-3 text-white" style={{ textShadow: "1px 1px 1px black" }} dangerouslySetInnerHTML={{ __html: configData?.Text }}></div>
                {user.username.length && (
                  <small
                    className="text-white-50"
                    style={{ textShadow: "1px 1px 1px black" }}
                  >
                    {user.username}
                  </small>
                )}
              </Col>
            </Row>
          </div>
          <div className="container bg-light rounded mb-3">
            {user.about !== "" && (
              <div className="mt-4 ms-3">
                <h1>About</h1>
                <small className="text-muted">{user.about}</small>
              </div>
            )}
            {user.services !== "" && (
              <div className="mt-3 ms-3">
                <h1>Services</h1>
                <small className="text-muted">{user.services}</small>
              </div>
            )}
            <hr />
            {(user.websiteLink !== "" ||
              user.facebookLink !== "" ||
              user.twitterLink !== "" ||
              user.linkedinLink !== "") && (
                <div className="mt-3 ms-3">
                  <h1>Social Links</h1>
                  {user.websiteLink && (
                    <Row className>
                      <Col md={{ offset: 2, span: 2 }}>
                        <p className="text-dark">Website</p>
                      </Col>
                      <Col md={{ offset: 1, span: 7 }}><Link to={user.websiteLink}>{user.websiteLink}</Link></Col>
                    </Row>
                  )}
                  {user.facebookLink && (
                    <Row className>
                      <Col md={{ offset: 2, span: 2 }}>
                        <p className="text-dark">Facebook</p>
                      </Col>
                      <Col md={{ offset: 1, span: 7 }}><Link to="#" onClick={() => { window.open(user.facebookLink); }}>{user.facebookLink}</Link></Col>
                    </Row>
                  )}
                  {user.twitterLink && (
                    <Row className>
                      <Col md={{ offset: 2, span: 2 }}>
                        <p className="text-dark">Twitter</p>
                      </Col>
                      <Col md={{ offset: 1, span: 7 }}><Link to="#" onClick={() => { window.open(user.facebookLink); }}>{user.twitterLink}</Link></Col>
                    </Row>
                  )}{" "}
                  {user.linkedinLink && (
                    <Row className>
                      <Col md={{ offset: 2, span: 2 }}>
                        <p className="text-dark">Linkedin</p>
                      </Col>
                      <Col md={{ offset: 1, span: 7 }}><Link to="#" onClick={() => { window.open(user.facebookLink); }}>{user.linkedinLink}</Link></Col>
                    </Row>
                  )}
                </div>
              )} */}
          {/* {(user.websiteLink !== "" ||
              user.facebookLink !== "" ||
              user.twitterLink !== "" ||
              user.linkedinLink !== "") && (
                <div className="mt-3 ms-3">
                  <hr />
                  <h1>Social Links</h1>
                  {user.websiteLink && (
                    <Row className>
                      <Col md={{ offset: 2, span: 2 }}>
                        <p className="text-dark">Website</p>
                      </Col>
                      <Col md={{ offset: 1, span: 7 }}><Link to="#" onClick={() => { window.open(user.facebookLink); }}>{user.websiteLink}</Link></Col>
                    </Row>
                  )}
                  {user.facebookLink && (
                    <Row className>
                      <Col md={{ offset: 2, span: 2 }}>
                        <p className="text-dark">Facebook</p>
                      </Col>
                      <Col md={{ offset: 1, span: 7 }}><Link to="#" onClick={() => { window.open(user.facebookLink); }}>{user.facebookLink}</Link></Col>
                    </Row>
                  )}
                  {user.twitterLink && (
                    <Row className>
                      <Col md={{ offset: 2, span: 2 }}>
                        <p className="text-dark">Twitter</p>
                      </Col>
                      <Col md={{ offset: 1, span: 7 }}><Link to="#" onClick={() => { window.open(user.facebookLink); }}>{user.twitterLink}</Link></Col>
                    </Row>
                  )}{" "}
                  {user.linkedinLink && (
                    <Row className>
                      <Col md={{ offset: 2, span: 2 }}>
                        <p className="text-dark">Linkedin</p>
                      </Col>
                      <Col md={{ offset: 1, span: 7 }}><Link to="#" onClick={() => { window.open(user.facebookLink); }}>{user.linkedinLink}</Link></Col>
                    </Row>
                  )}
                </div>
              )} */}
          {/* {user.featured.length > 0 && (
              <div className="mt-3 ms-3">
                <hr />
                {user.featured.map((featur, index) => (
                  <Card item sm={12} md={2} key={index}>
                    <img alt="" src={featur.url} width="187px" height="181px" />
                  </Card>
                ))}
              </div>
            )}
          </div> */}
          <div className="container bg-light rounded min-vh-100 mb-3 mt-5" >
            <div className="mt-3 ms-3">

              <h2 className="pt-3 text-center">About Us</h2>
              <div className="pb-4 mt-3" dangerouslySetInnerHTML={{ __html: configData?.Text }}></div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
export default About;
